import React from 'react';
import { Card, CardActions, CardContent, Typography, useMediaQuery } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Div from 'app/components/shared/Div';
import { Colors, ColorsV2 } from 'app/constants/color';

const CardItem = ({ data, loading, icon, title, sx }) => {
  const matchesExtraLargeScreen = useMediaQuery('(min-width: 1700px)');
  const matchesDoubleXLScreen = useMediaQuery('(min-width: 1900px)');
  const matchesTripleXLScreen = useMediaQuery('(min-width: 2000px)');
  return (
    <Card sx={{ ...sx, height: '11vh', background: ColorsV2.secondary }}>
      <CardActions disableSpacing sx={{ p: 0, alignItems: 'stretch', height: '100%' }}>
        <Div
          sx={{
            display: 'flex',
            width: '15vh',
            justifyContent: 'flex-end',
            alignItems: 'center',
            backgroundColor: 'common.white',
            borderRadius: '50%',
            outline: 'solid 10px rgba(255, 255, 255, 0.2)',
            margin: matchesTripleXLScreen
              ? '0 10px 0 -5.5rem'
              : matchesDoubleXLScreen
              ? '0 10px 0 -5rem'
              : matchesExtraLargeScreen
              ? '0 10px 0 -4.35rem'
              : '0 10px 0 -4rem',
          }}
        >
          <Div
            sx={{
              display: 'flex',
              minWidth: '7%',
              height: '7%',
              mr: '6px',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {icon}
          </Div>
        </Div>
        <CardContent sx={{ p: 2.5, flex: 1, alignSelf: 'center' }}>
          {loading ? (
            <CircularProgress sx={{ color: Colors.secondary }} />
          ) : (
            <Typography variant={'h5'} fontSize={'0.8em'} color={ColorsV2.white}>
              {data ? data : 0}
            </Typography>
          )}
          <Typography variant={'h6'} fontSize={'0.8em'} color={ColorsV2.white} mb={0}>
            {title}
          </Typography>
        </CardContent>
      </CardActions>
    </Card>
  );
};

export default CardItem;
